export default __webpack_public_path__ + "static/media/9.6f1d2e4e.jpg";